import { render, staticRenderFns } from "./CommunityElder.vue?vue&type=template&id=49f66c34&scoped=true&"
import script from "./CommunityElder.vue?vue&type=script&lang=js&"
export * from "./CommunityElder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49f66c34",
  null
  
)

export default component.exports